<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-0 px-0">
        <v-layout>
            <v-flex pb-2 pt-5>
                <h2>Транспортное средство</h2>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md4 lg2 py-0 style="align-self: flex-end">
                <v-checkbox
                    class="checkbox-plate"
                    style="margin-top: 0; height: 25px;"
                    label="Без номера"
                    v-model="value.noLicensePlate"
                    @change="handleNoLicensePlate"
                />
                <v-text-field
                    v-if="!value.noLicensePlate"
                    v-model="value.licensePlate"
                    :rules="[rules.required, rules.base, rules.licensePlateLength]"
                    label="Гос номер"
                    required
                    @input="value.licensePlate = value.licensePlate.toUpperCase()"
                    :disabled="value.noLicensePlate"
                    @keyup.native="value.licensePlate = removeSymbols(value.licensePlate)"
                />
                <v-text-field
                    v-if="value.noLicensePlate"
                    label="Гос номер"
                    :disabled="true"
                />
            </v-flex>

            <v-flex xs12 sm6 md4 lg3 py-0 style="align-self: flex-end;">
                <v-autocomplete
                    v-model="value.mark"
                    :items="transportMarks"
                    :rules="[rules.required]"
                    :search-input="markSearchSync"
                    @update:searchInput="markSearch"
                    label="Марка"
                    placeholder="Введите марку по буквам"
                    no-data-text="Марка ТС не найдена"
                    auto-select-first
                    validate-on-blur
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0 style="align-self: flex-end;">
                <!-- TODO: поменять потом на autocomplete -->
                <v-combobox
                    v-model="value.model"
                    :items="transportModels"
                    :rules="[rules.required]"
                    label="Модель"
                    placeholder="Введите модель по буквам"
                    :search-input="modelSearchSync"
                    @update:searchInput="modelSearch"
                    no-data-text="Модель ТС не найдена"
                    auto-select-first
                    validate-on-blur
                    required
                />
            </v-flex>

            <v-flex
                v-if="modelCategories.length > 1"
                xs12 sm6 md4 lg3 py-0
                style="align-self: flex-end;"
            >
                <v-select
                    v-model="value.category"
                    :items="modelCategories"
                    label="Категория ТС"
                    no-data-text="Для данной модели нет категорий"
                />
            </v-flex>

            <v-flex xs12 sm12 md6 lg4 py-0 style="align-self: flex-end;">
                <v-radio-group
                    row
                    v-model="value.idType"
                    style="margin-bottom: -25px"
                    @change="nullNumberValues"
                >
                    <v-radio
                        label="VIN"
                        value="vin"
                    />
                    <v-radio
                        label="№ Кузова"
                        value="bodyNumber"
                    />
                    <v-radio
                        label="№ Шасси"
                        value="chassisNumber"
                    />
                </v-radio-group>

                <v-text-field
                    pt-0
                    v-if="value.idType === 'vin'"
                    v-model="value.vin"
                    :rules="[rules.required, rules.vin, rules.base]"
                    label="VIN (Идентификационный номер)"
                    @input="vinOtoZeroAndUpperCase(value.vin)"
                    validate-on-blur
                    required
                    @keyup.native="value.vin = removeSymbols(value.vin)"
                />
                <v-text-field
                    pt-0
                    v-if="value.idType === 'bodyNumber'"
                    v-model="value.bodyNumber"
                    :rules="[rules.required, rules.bodyNumber, rules.base]"
                    label="№ Кузова"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.bodyNumber = stringToUpper(value.bodyNumber)"
                    validate-on-blur
                    required
                    @keyup.native="value.bodyNumber = removeSymbols(value.bodyNumber)"
                />
                <v-text-field
                    pt-0
                    v-if="value.idType === 'chassisNumber'"
                    v-model="value.chassisNumber"
                    :rules="[rules.required, rules.chassisNumber, rules.base]"
                    label="№ Шасси"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.chassisNumber = stringToUpper(value.chassisNumber)"
                    validate-on-blur
                    required
                    @keyup.native="value.chassisNumber = removeSymbols(value.chassisNumber)"
                />
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg3 pt-3 pb-0 style="align-self: flex-end">
                <v-text-field
                    v-model.number="value.yearIssue"
                    label="Год выпуска"
                    :rules="[rules.required]"
                    mask="####"
                    validate-on-blur
                    required
                />
            </v-flex>

            <v-flex xs12 sm6 md6 lg3 py-0 style="align-self: flex-end">
                <v-text-field
                    v-if="value.category !== 'D'"
                    v-model.number="hpInput"
                    :rules="[rules.required, rules.hp]"
                    type="number"
                    step="0.1"
                    label="Мощность двигателя (л. с.)"
                    validate-on-blur
                    required
                    @blur="syncFromHp"
                    @keypress="onlyNumberAndDot($event)"
                    @input="replaceComma(hpInput)"
                />
                <v-text-field
                    v-if="value.category === 'D'"
                    v-model.number="value.seats"
                    :rules="[rules.required, rules.seats]"
                    mask="###"
                    label="Количество пассажирских мест"
                    validate-on-blur
                    required
                />
            </v-flex>

            <v-flex xs12 sm6 md6 lg3 py-0 style="align-self: flex-end">
                <v-text-field
                    v-if="value.category !== 'D'"
                    v-model.number="kwInput"
                    :rules="[rules.required, rules.kw]"
                    type="number"
                    step="0.1"
                    label="Мощность, кВт"
                    validate-on-blur
                    required
                    @blur="syncFromKw"
                    @keypress="onlyNumberAndDot($event)"
                    @input="replaceComma(kwInput)"
                />
            </v-flex>

            <v-flex
                xs12 sm6 md6 lg3 py-0 style="align-self: flex-end"
                v-if="value.category === 'C'"
            >
                <v-text-field
                    v-if="value.category === 'C'"
                    v-model.number="value.maxMass"
                    :rules="[rules.required, rules.maxMass]"
                    mask="#####"
                    label="Максимальная разрешенная масса (кг.)"
                    validate-on-blur
                    required
                />
            </v-flex>

            <v-flex xs12 sm6 md3 pb-3 style="align-self: flex-end">
                <span style="font-size: 12px">Категория</span>
                <p>{{ this.categories[value.category] }}</p>
            </v-flex>

            <v-flex
                v-if="value.category === 'B' || value.category === 'C'"
                xs12 sm6 md3
                style="align-self: flex-end"
            >
                <v-checkbox
                    style="margin-top: 0;"
                    label="Используется с прицепом"
                    v-model="value.withTrailer"
                />

                <v-checkbox
                    style="margin-top: 0;"
                    label="Следует к месту регистрации (транзит)"
                    v-model="localTransition"
                    :disabled="value.noLicensePlate"
                />
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex pb-0>
                <h3 style="display: inline-block;">Тип документа на транспортное средство</h3>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex py-0 style="margin-bottom: -25px">
                <v-radio-group
                    row
                    v-model="value.carDoc.type"
                    @change="value.carDoc.series = ''; value.carDoc.number = ''"
                >
                    <v-radio
                        label="ПТС"
                        value="36"
                        class="pb-3"
                    />
                    <v-radio
                        label="СТС - Свидетельство о регистрации ТС"
                        value="37"
                        class="pb-3"
                    />
                </v-radio-group>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md3 lg2 py-0>
                <v-text-field
                    v-model="value.carDoc.series"
                    label="Серия"
                    :rules="value.carDoc.type === '36' ? [rules.ptsSeriesLength] : [rules.srtsSeriesLength]"
                    @paste="removeSpacesOnPaste($event, value.series)"
                    @keyup.native="value.carDoc.series = removeSymbols(value.carDoc.series)"
                />
            </v-flex>
            <v-flex xs12 sm6 md3 lg2 pt-0>
                <v-text-field
                    v-model="value.carDoc.number"
                    label="Номер"
                    :rules="value.carDoc.type === '36' ? [rules.required, rules.ptsNumberLength] : [rules.required, rules.srtsNumberLength]"
                    @paste="removeSpacesOnPaste($event, value.number)"
                    required
                    @keyup.native="value.carDoc.number = removeSymbols(value.carDoc.number)"
                />
            </v-flex>
            <v-flex xs12 sm6 md3 lg2 pt-0>
                <osago-date
                    v-model="value.carDoc.date"
                    label="Дата выдачи"
                    :max="dateToday"
                    :min="value.yearIssue ? value.yearIssue+'-01-01' : null"
                    :isHideMobile="true"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import _ from "lodash";
import helperMixin from '../../mixins/helper';
export default {
    mixins: [helperMixin],
    props: [
        'value',
        'dateToday',
        'transition',
    ],
    data: () => ({
        markSearchSync: '',
        modelSearchSync: '',
        transportMarks: [],
        transportModels: [],
        modifications: [],
        modelCategories: [],
        categories: {
            A: 'Мотоцикл (Категория A)',
            B: 'Легковое (Категория B)',
            C: 'Грузовое (Категория C)',
            D: 'Автобус (Категория D)'
        },
        rules: {
            required: v => !!v || 'Обязательное поле',
            russianOnly: v => !(/[^А-Я0-9]/.test(v)) || 'Допускаются только русские буквы',
            power: v => /^\d{1,4}$/.test(v) || 'Неверный формат',
            maxMass: v => /^\d{4,5}$/.test(v) || 'Неверный формат',
            seats: v => /^\d{1,3}$/.test(v) || 'Неверный формат',
            vin: v => /^[\dABCDEFGHJKLMNPRSTUVWXYZ\*]{17}$/.test(v) ||
                'Должен содержать 17 знаков. Не использовать I (i), O (o), Q (q)',
            bodyNumber: v => /^[\dABCDEFGHJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
            chassisNumber: v => /^[\dABCDEFGHJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
            license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            yearIssue: v => this.isYearValidRule(v),
            // это правило будет меняться в зависимости от категории и цели использования ТС
            numberRule: v => /^[АВЕКМНОРСТУХ\d]{4,}$/.test(v) || 'Неверный формат',
            pts: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            srts: v => /^\d{15}$/.test(v) || 'Неверный формат',
            base: v => /^[\dA-Za-zА-Яа-яЁё]*$/.test(v) || 'Неверный формат',
            licensePlateLength: v => {
                if (!v) return true;
                return (v.length >= 3 && v.length <= 11) || 'Недопустимое количество символов';
            },
            ptsSeriesLength: v => {
                if (!v) return true;
                return (v.length >= 2 && v.length <= 4) || 'Недопустимое количество символов';
            },
            ptsNumberLength: v => {
                if (!v) return true;
                return (v.length >= 3 && v.length <= 20) || 'Недопустимое количество символов';
            },
            srtsSeriesLength: v => {
                if (!v) return true;
                return (v.length >= 2 && v.length <= 5) || 'Недопустимое количество символов';
            },
            srtsNumberLength: v => {
                if (!v) return true;
                return (v.length >= 6 && v.length <= 10) || 'Недопустимое количество символов';
            },
            hp: v => (v > 0 && !isNaN(v)) || 'Введите положительное число',
            kw: v => (v > 0 && !isNaN(v)) || 'Введите положительное число',
        },
        localTransition: this.transition,
        hpInput: null,
        kwInput: null,
    }),

    created() {
        const url = '/dict/marks';

        axios.get(url)
            .then(response => {
                if (response && response.data) {
                    this.transportMarks = response.data;
                }
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        allowedModifications: function() {
            if (!this.modifications) {
                return [];
            }
            let names = [];
            const value = this.value;
            this.modifications.forEach(function(item) {
                if (value.category === item.category &&
                    ((value.yearIssue && item.years.indexOf(value.yearIssue) !== -1) || !value.yearIssue) &&
                    ((value.power && value.category !== 'C' && value.category !== 'D' && item.power == value.power) ||
                        !value.power || value.category === 'C' || value.category === 'D') &&
                    ((value.maxMass && value.category === 'C' && item.maxWeight == value.maxMass) ||
                        !value.maxMass || value.category !== 'C') &&
                    ((value.seats !== null && value.seats !== undefined && value.category === 'D' && item.seats == value.seats) ||
                        !value.seats || value.category !== 'D')
                ) {
                    names.push({
                        'name': item.name,
                        'code': item.carCode,
                        'power': item.power,
                        'maxWeight': item.maxWeight,
                        'seats': item.seats,
                        'years': item.years
                    });
                }
            });
            return names.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
            });
        },
        setModification() {
            return {
                'category': this.value.category,
                'power': this.value.power,
                'year': this.value.year,
                'maxMass': this.value.maxMass,
                'seats': this.value.seats,
                'allowedMods': this.allowedModifications,
                'time': Date.now()
            };
        },
    },

    watch: {
        setModification() {
            if (this.allowedModifications.length &&
                ((this.value.maxMass && this.value.category === 'C') ||
                    (this.value.seats !== null && this.value.seats !== undefined && this.value.category === 'D') ||
                    (this.value.power && this.value.category !== 'C' && this.value.category !== 'D'))) {
                this.value.carCode = this.allowedModifications[0].code;
            } else {
                this.value.carCode = null;
            }
        },
        'value.carDoc.type': {
            handler() {
                if (this.value.carDoc.type === '37') {
                    // при указании документа СТС ввод госномера обязателен
                    this.value.noLicensePlate = false;
                    this.value.docType = 'sts';
                } else {
                    this.value.docType = 'pts';
                }
            }
        },
        transition(newVal) {
            this.localTransition = newVal;
        },
        localTransition(newVal) {
            this.$emit('update:transition', newVal);
        },
        'value.power': {
            handler(newVal) {
                if (newVal && !isNaN(newVal)) {
                    this.hpInput = newVal
                    this.kwInput = (newVal / 1.36).toFixed(1)
                } else {
                    this.hpInput = null
                    this.kwInput = null
                }
            },
            immediate: true
        },
    },

    methods: {
        modelSearch(model) {
            if (model && model !== this.value.model) {
                this.value.model = '';
                const that = this;
                setTimeout(() => {
                    that.modelSearchSync = model;
                }, 0);
            }
            this.loadModel(this.value.mark, model);
        },
        markSearch(mark) {
            if (mark && mark !== this.value.mark) {
                this.value.mark = '';
                this.value.model = '';
                const that = this;
                setTimeout(() => {
                    that.markSearchSync = mark;
                }, 0);
            }
            this.loadModels(mark);
        },
        loadModels(mark) {
            if (!mark) {
                return;
            }

            mark = mark.replace(/\//g, "@@@");
            const url = '/dict/models/';

            axios.get(url + mark).then(response => {
                this.transportModels = response.data;
                if (!!this.value.model && !this.transportModels.includes(this.value.model)) {
                    this.$nextTick(function () {
                        this.value.model = null;
                    });
                }
            }).catch(error => {
                console.log('Load models error mark = ' + mark + ' :', error);
            });
        },
        loadModel(mark, model) {
            if (!mark || !model) {
                return;
            }
            mark = mark.replace(/\//g, "@@@");
            model = model.replace(/\//g, "@@@");
            const url = '/dict/model-info/';
            axios.get(url + mark + '/' + model).then(response => {
                if (response.data) {
                    this.modelCategories = response.data.categories;
                    if (response.data.categories.length === 0) {
                        this.value.category = null;
                        this.modifications = [];
                        return;
                    } else if (response.data.categories.indexOf(this.value.category) === -1) {
                        this.value.category = response.data.categories[0];
                    }
                    this.loadModifications(mark, model, this.value.category);
                } else {
                    console.log(response);
                }
            }).catch(error => {
                console.log('Load model info mark = ' + mark + ', model = ' + model + ' error: ', error);
            });
        },
        loadModifications(mark, model, category) {
            if (!mark || !model || !category) {
                return;
            }
            mark = mark.replace(/\//g, "@@@");
            model = model.replace(/\//g, "@@@");
            const url = '/dict/model-info-category/';
            axios.get(url + mark + '/' + model + '/' + category).then(response => {
                if (response.data) {
                    this.modifications = response.data.modifications;
                    //this.checkAvtokodAllowedValues();
                } else {
                    console.log(response);
                }
            }).catch(error => {
                console.log('Load modifications mark = ' +
                    mark + ', model = ' + model +
                    ', category = ' + category + ' error: ', error);
            });
        },
        nullNumberValues() {
            this.value.vin = null;
            this.value.bodyNumber = null;
            this.value.chassisNumber = null;
        },
        vinOtoZeroAndUpperCase(value) {
            if (!value) return null;
            if (value.includes('*')) return;
            this.value.vin = value.toString().toUpperCase().replace(/O/g, '0');
            return value;
        },
        stringToUpper(value) {
            if (!value) return null;
            return value.toString().toUpperCase();
        },
        isYearValidRule: function (year) {
            if (this.isInvalidYear(year)) {
                return 'Неверно указан год выпуска';
            }
            return false;
        },
        isInvalidYear: function (year) {
            return year < 1930 || year > this.dateToday.slice(0,4);
        },
        removeSymbols: function (val) {
            if (!val) return '';
            const textRegex = /[^0-9A-Za-zА-ЯЁа-яё\- ]/g;
            val = val
                .toString()
                .replace(/[ ]+/g, ' ')
                .replace(/[-]+/g, '-')
                .replace(/^[ |-]/g, '')
                .replace(/ -/g, '-')
                .replace(/- /g, '-')
                .replace(textRegex, '');
            return val;
        },
        handleNoLicensePlate(val) {
            if (val) {
                this.value.licensePlate = null;

                this.$emit('update:transition', true);
            }
        },
        syncFromHp() {
            let num = this.normalize(this.hpInput)
            if (num !== null) {
                const hp = Math.round(num)
                this.value.power = hp
                this.hpInput = hp
                this.kwInput = (hp / 1.36).toFixed(1)
            } else {
                this.value.power = null
                this.hpInput = null
                this.kwInput = null
            }
        },
        syncFromKw() {
            let num = this.normalize(this.kwInput)
            if (num !== null) {
                const hp = Math.round(num * 1.36)
                this.value.power = hp
                this.hpInput = hp
                this.kwInput = (hp / 1.36).toFixed(1)
            } else {
                this.value.power = null
                this.hpInput = null
                this.kwInput = null
            }
        },
        onlyNumberAndDot(e) {
            const char = String.fromCharCode(e.keyCode || e.which)
            if (!/[0-9.,]/.test(char)) {
                e.preventDefault()
            }
        },
        replaceComma(inputValue) {
            if (typeof inputValue === 'string') {
                inputValue = inputValue.replace(',', '.')
            }
        },
        normalize(val) {
            if (!val) return null
            val = String(val).replace(',', '.')
            let num = parseFloat(val)
            return isNaN(num) || num <= 0 ? null : num
        },
    },
}
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
input {
    -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/transit-osago/TransitTransport.vue